/* @flow */

import React from 'react';
import DatePicker from 'react-datepicker';

type Props = {
  name?: string,
  label?: string,
  value: object,
  showTimeSelect?: boolean,
  onChange: (value: object) => void,
};

const Date = ({
  name = 'value',
  label = 'Date',
  value,
  showTimeSelect,
  onChange,
  ...props
}: Props) => {
  const dateFormat = showTimeSelect ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY';

  const DateInput = ({ value, onClick, onChange }) => (
    <input
      type="text"
      value={value}
      onChange={onChange}
      onClick={onClick}
      className="react-datepicker-ignore-onclickoutside"
      name={`date.${name}`}
    />
  );

  return (
    <div className="ui field">
      <label>{label}</label>
      <style>
        {`.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
            padding-left: 0;
            padding-right: 0;
          }`}
      </style>
      <DatePicker
        customInput={<DateInput />}
        selected={value}
        onChange={onChange}
        showTimeSelect={showTimeSelect}
        locale="fr"
        dateFormat={dateFormat}
        timeFormat="HH:mm"
        timeIntervals={30}
        {...props}
      />
    </div>
  );
};

export default Date;



// WEBPACK FOOTER //
// ./src/modules/calendar/components/Date.js